var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apexchart',{ref:"status-chart",staticClass:"donut-chart",attrs:{"options":_vm.options,"series":_vm.series,"type":"donut","width":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }